import { render, staticRenderFns } from "./pastCohort.vue?vue&type=template&id=355c729a&"
import script from "./pastCohort.vue?vue&type=script&lang=js&"
export * from "./pastCohort.vue?vue&type=script&lang=js&"
import style0 from "./pastCohort.vue?vue&type=style&index=0&id=355c729a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports